import React from 'react';
import { Image } from '@hz-design-system/web-ui';
import { NoImageItemProps } from './types';
import ListingFavoriteIcon from './components/ListingFavoriteIcon';

const NoImageItem: React.FC<NoImageItemProps> = ({
  aspectRatio = 'landscape',
  showFavoriteIcon = false,
  isFavorite = false,
  onFavorite,
  favoriteIconAriaLabel,
  descriptionElementId,
}) => {
  return (
    <Image
      title="No image available"
      alt="No image available"
      src=""
      data-src=""
      loading="lazy"
      decoding="async"
      fetchpriority="low"
      aspectRatio={aspectRatio}
    >
      {showFavoriteIcon ? (
        <ListingFavoriteIcon
          isFavorite={isFavorite}
          onFavorite={onFavorite}
          ariaLabel={favoriteIconAriaLabel}
          aria-describedby={descriptionElementId}
        />
      ) : undefined}
    </Image>
  );
};

export default NoImageItem;
